import { render } from "./KenticoAdvertisement.vue?vue&type=template&id=fd552908&scoped=true"
import script from "./KenticoAdvertisement.vue?vue&type=script&lang=js"
export * from "./KenticoAdvertisement.vue?vue&type=script&lang=js"

import "./KenticoAdvertisement.vue?vue&type=style&index=0&id=fd552908&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd552908"]])

export default __exports__